<template>
  <div>
    <div style="text-align: left; background-color: #EFF3FF; padding-left: 10px; padding-top: 1px; padding-bottom: 5px; font-size: 16px">
      <p style="font-size: 20px; font-weight: bold">2048游戏</p>
      <p>2048游戏是一款数字益智游戏，如图所示。具体游戏规则如下：</p>
      <p>① 玩家每次可以选择上下左右其中一个方向移动。</p>
      <p>② 每移动一次，所有数字方块都会往移动的方向靠拢。</p>
      <p>③ 相同数字方块在靠拢时会相加。</p>
      <p>④ 每次移动完成后，系统会在空白的方块中随机添加2或4。</p>
      <p>⑤ 当所有方块中填满数字并不能相加时，游戏结束。</p>
      <p>⑥ 玩家的得分为相同数字之和的累加。</p>
      <p>根据上述游戏规则，该游戏需实现以下功能：</p>
      <p>① 显示游戏界面。</p>
      <p>② 上下左右移动。</p>
      <p>③ 添加随机数字。</p>
      <p>④ 游戏是否结束。</p>
      <p>为方便读者理解各功能之间的联系，此处画出程序的流程图，如图所示。</p>

    </div>
    <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 10px">

      <div style="width: 800px;  text-align: left; color: white; font-size: 15px; line-height: 25px; ">
        <div style="color: white; text-align: left; font-weight: bold">示例代码：</div>
        <div style="padding: 10px; background-color: rgb(43, 43, 43); margin-top: 5px;  height: 650px; overflow-y: auto">
          <div>
            <p><br></p>
            <pre><code class="language-python"># -*- coding: utf-8 -*-
"""
Created on Thu Oct 12 22:21:37 2023

@author: liuxijuan
"""
import random

matix = [[0 for i in range(4)] for i in range(4)] #初始化生成一个二维列表
score = 0 #score记录游戏分数

#print(matix)

def display():
    print(' \033[1;31;42m 欢迎进入 2048 小游戏  \033[0m')
    print('\r'
          '┌────┬────┬────┬────┐\n'
          '|%4s|%4s|%4s|%4s|\n'
          '├────┬────┬────┬────┤\n'
          '|%4s|%4s|%4s|%4s|\n'
          '├────┬────┬────┬────┤\n'
          '|%4s|%4s|%4s|%4s|\n'
          '├────┬────┬────┬────┤\n'
          '|%4s|%4s|%4s|%4s|\n'
          '└────┴────┴────┴────┘'

        % (ifzero (matix[0][0]), ifzero(matix[0][1]),
           ifzero (matix[0][2]), ifzero(matix[0][3]),
           ifzero (matix[1][0]), ifzero(matix[1][1]),
           ifzero (matix[1][2]), ifzero(matix[1][3]),
           ifzero (matix[2][0]), ifzero(matix[2][1]),
           ifzero (matix[2][2]), ifzero(matix[2][3]),
           ifzero (matix[3][0]), ifzero(matix[3][1]),
           ifzero (matix[3][2]), ifzero(matix[3][3]),)
        )
    print('\033[1;31;47m 得分:%s  \033[0m' %  (score))

def ifzero(s):
    return str(s) if s != 0 else ''

def init():
    initNumFlag = 0
    while True:
        k = 2 if random.randrange(0,10) &gt; 1 else 4  #随机生成2或4
        #生成矩阵初始化的下标 <span v-if="showAnswer" style="color: #dd6161">答案：divmod(random.randrange(0,16),4)</span>
        s = <input type="text" v-model="yourAnswer1" style="width: 300px"></input>
        if matix[s[0]][s[1]] == 0:  #只有当其值不为 0 时才赋值,避免第二个值重复
            matix[s[0]][s[1]] = k
            initNumFlag += 1
            if initNumFlag == 2:
                break
    display()


def moveRight():
    global score
    for i in range(4):
        for j in range(3,0,-1):
            for k in range(j - 1,-1,-1):
                if matix[i][k] &gt; 0:
                    if matix[i][j] == 0:
                        if k &gt; 0 and matix[i][k] == matix[i][k - 1]:
                            matix[i][k] *= 2
                            #将当前数作为 score 加上 <span v-if="showAnswer" style="color: #dd6161">答案：matix[i][k]</span>
                            score += <input type="text" v-model="yourAnswer2" style="width: 200px"></input>
                            matix[i][k - 1] = 0
                        if k == 2 and matix[i][k - 1] == 0 and \
                            matix[i][k] == matix[i][k - 2]:
                            matix[i][k] *= 2
                            score += matix[i][k]
                            matix[i][k - 2] = 0
                        matix[i][j] = matix[i][k]
                        matix[i][k] = 0
                    elif matix[i][j] == matix[i][k]:
                        matix[i][j] *= 2
                        score += matix[i][j]
                        matix[i][k] = 0
                    break
# 定义一个moveLeft() 方法 <span v-if="showAnswer" style="color: #dd6161">答案： def moveLeft():</span>
<input type="text" v-model="yourAnswer3" style="width: 200px"></input>
    global score
    for i in range(4):
        for j in range(3):
            for k in range(j + 1, 4):
                if matix[i][k] &gt; 0:
                    if matix[i][j] == 0:
                        if k &lt; 3 and matix[i][k] == matix[i][k + 1]:
                            matix[i][k] *= 2
                            score += matix[i][k]
                            matix[i][k + 1] = 0
                        if k == 1 and matix[i][k + 1] == 0 and \
                            matix[i][k] == matix[i][k + 2]:
                            matix[i][k] *= 2
                            score += matix[i][k]
                            matix[i][k + 2] = 0
                        matix[i][j] = matix[i][k]
                        matix[i][k] = 0
                    elif matix[i][j] == matix[i][k]:
                        matix[i][j] *= 2
                        score += matix[i][j]
                        matix[i][k] = 0
                    break

def moveUp():
    global score
    for j in range(4):
        for i in range(3):
            for k in range(i + 1, 4):
                if matix[k][j] &gt; 0:
                    if matix[i][j] == 0:
                        if k &lt; 3 and matix[k][j] == matix[k + 1][j]:
                            matix[k][j] *= 2
                            score += matix[k][j]
                            matix[k + 1][j] = 0
                        if k == 1 and matix[k + 1][j] == 0 and \
                            matix[k][j] == matix[k + 2][j]:
                            matix[k][j] *= 2
                            score += matix[k][j]
                            matix[k + 2][j] = 0
                        matix[i][j] = matix[k][j]
                        matix[k][j] = 0
                    elif matix[i][j] == matix[k][j]:
                        matix[i][j] *= 2
                        score += matix[i][j]
                        matix[k][j] = 0
                    break

def moveDown():
    global score
    for j in range(4):
        for i in range(3, -1, -1):
            for k in range(i - 1, -1, -1):
                if matix[k][j] &gt; 0:
                    if matix[i][j] == 0:
                        if k &gt; 0 and matix[k][j] == matix[k - 1][j]:
                            matix[k][j] *= 2
                            score += matix[k][j]
                            matix[k - 1][j] = 0
                        if k == 2 and matix[k - 1][j] == 0 and \
                            matix[k][j] == matix[k - 2][j]:
                            matix[k][j] *= 2
                            score += matix[k][j]
                            matix[k - 2][j] = 0
                        matix[i][j] = matix[k][j]
                        matix[k][j] = 0
                    elif matix[i][j]==matix[k][j]:
                        matix[i][j]*=2
                        score+=matix[i][j]
                        matix[k][j]=0
                    # 结束本次循环  <span v-if="showAnswer" style="color: #dd6161">答案： break</span>
                    <input type="text" v-model="yourAnswer4" style="width: 200px"></input>


def addRandomNum() :

    # 检查矩阵是否已满
    if all(matix[i][j] != 0 for i in range(4) for j in range(4)):
        display()
        return

    while True :
        k = 2 if random.randrange(0, 10) &gt; 1 else 4
        s = divmod(random.randrange(0, 16), 4)
        if matix[s[0]][s[1]] == 0:
            matix[s[0]][s[1]] = k
            break
    display()

def checkOver():
    for i in range(4) :
        for j in range(3):
            if matix[i][j] == 0 or (j+1&lt;4 and (matix[i][j] == matix[i][j + 1] or \
                matix[j][i] == matix[j + 1][i])):
                    return True
    return False

def main():
    flag = True
    init()
    while flag:  #循环标志
        d = input('\033[1;36;1m W:上 S:下 A:左 D:右 Q:退出 :\033[0m')
        if d == 'A':  # 左移
            moveLeft()
        elif d == 'S':  # 下移
            moveDown()
        elif d == 'W':  # 上移
            moveUp()
        elif d == 'D':  # 右移
            moveRight()
        elif d == 'Q':  # 退出
            break
        else:  # 对用户的其他输入不处理
            continue
        addRandomNum()
        if not checkOver():
            print('游戏结束')
            flag = False

if __name__ == '__main__':
    main()


</code></pre>
            <p><br></p>
          </div>
        </div>
      </div>
      <div style="width: calc(100vw - 950px);  text-align: left; color: white; font-size: 15px; line-height: 25px; ">
        <div
          style="color: white; text-align: left; font-weight: bold; display: flex; justify-content: space-between; align-items: center">
          <span>
            运行效果：
          </span>
          <el-button type="success" @click="runCode">运行</el-button>
        </div>
        <div style="padding: 10px; background-color: white; margin-top: 5px; height: 600px;">
          <div style="padding: 10px">
            {{chooseWord}}
            <embed :src="url" style="width: 100%; height: 580px">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { addExpScore } from '../../request/api';

  export default {
    data() {
      return {
        url: '',
        //words: ['pizza', 'fairy', 'teeth', 'shirt', 'otter', 'plane'],
        words: ['otter'],
        chooseWord: '',
        showWordArray: [],
        word: [],
        guess: '',
        chances: 3,
        message: '',
        zcdCode: [],
        inputVal: '',
        answer1: 'divmod(random.randrange(0,16),4)',
        answer2: 'matix[i][k]',
        answer3: 'def moveLeft():',
        answer4: 'break',
        answer5: '',
        yourAnswer1: '',
        yourAnswer2: '',
        yourAnswer3: '',
        yourAnswer4: '',
        yourAnswer5: '',
        scoreItemId: 'item123123',
        haveSubmit: false,
        showAnswer: false
      };
    },
    created() {
      this.chooseWord = this.words[Math.floor(Math.random() * this.words.length)];

      this.word = this.chooseWord.split('');
      this.showWordArray = new Array();
      for (let i = 0; i < this.word.length; i++) {
        this.showWordArray.push("?");
      }
    },
    methods: {
      runCode() {
        if (this.yourAnswer1 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }
        if (this.yourAnswer2 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }
        if (this.yourAnswer3 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }
        if (this.yourAnswer4 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }

        let totalScore = 0;
        let fin = 1;
        if (this.answer1 === this.yourAnswer1) {
          totalScore += 25;
        } else {
          fin = 0;
        }
        if (this.answer2 === this.yourAnswer2) {
          totalScore += 25;
        } else {
          fin = 0;
        }
        if (this.answer3 === this.yourAnswer3) {
          totalScore += 25;
        } else {
          fin = 0;
        }
        if (this.answer4 === this.yourAnswer4) {
          totalScore += 25;
        } else {
          fin = 0;
        }

        if (fin === 0) {
          this.showAnswer = true;

          if (!this.haveSubmit) {
            let param = {
              score: totalScore,
              expName: "2048游戏"
            }
            addExpScore(param).then(
              resp => {
                if (resp.code === 1) {
                  this.msg = "提交成绩成功了,本次得分：" + totalScore + "分";
                  this.$message.success(this.msg);
                  this.haveSubmit = true
                } else {
                  this.msg = resp.msg;
                  this.$message.error(resp.msg);
                }
              }
            ).catch(err => {
              console.log(err)
            })
            this.$message.warning("请根据正确答案填充好缺失,再次运行");

          }
        } else {
          if (!this.haveSubmit) {
            let param = {
              score: totalScore,
              expName: "2048游戏"
            }
            addExpScore(param).then(
              resp => {
                if (resp.code === 1) {
                  this.msg = "提交成绩成功了,本次得分：" + totalScore + "分";
                  this.$message.success(this.msg);
                  this.haveSubmit = true
                } else {
                  this.msg = resp.msg;
                  this.$message.error(resp.msg);
                }
              }
            ).catch(err => {
              console.log(err)
            })
            this.haveSubmit = true
          }
          this.url = window.__HEALTH_URL__.G2048
        }

      },
      checkGuess() {
        if (this.chances <= 0) {
          return
        }
        if (this.guess.length === 1) {
          if (this.word.includes(this.guess)) {

            for (let i = 0; i < this.word.length; i += 1) {
              if (this.word[i] === this.guess) {
                this.showWordArray[i] = this.guess;
              }
            }
            let right = true;
            for (let i = 0; i < this.showWordArray.length; i++) {
              if (this.showWordArray[i] === "?") {
                right = false
              }
            }
            if (right) {
              this.message = '恭喜你，猜对了！';
            }
          } else {
            this.chances -= 1;
            if (this.chances === 0) {
              this.message = '游戏结束';
            } else {
              this.message = `错误，你丢了一条命，还剩${this.chances}次机会`;
            }
          }
        } else if (this.guess === this.chooseWord) {
          this.message = '恭喜你，猜对了！';
        } else {
          this.chances -= 1;
          if (this.chances === 0) {
            this.message = '游戏结束';
          } else {
            this.message = `错误，你丢了一条命，还剩${this.chances}次机会`;
          }
        }
        this.guess = '';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/lw/sz02.vue